export default __webpack_public_path__ + "static/media/support-notes-main-elcronista.fbd9d988.png";